import dateToStandart from "@/libs/date/dateToStandart";
import findContentFields from "@/libs/findContentFields";

function transformDateFields(dateFields: string[], sourceData: any): any {
    if (Array.isArray(sourceData)) {
        sourceData.forEach((item: any) => {
            if (findContentFields(item, dateFields)) {
                dateFields.forEach((field: string) => {
                    item[field] = dateToStandart(item[field])
                })
            }
        });
    } else {
        Object.entries(sourceData).forEach((item: any) => {
            const key = item[0];
            const value = item[1];

            if (findContentFields(key, dateFields)) {
                dateFields.forEach((field: string) => {
                    if (field === key) {
                        sourceData[key] = dateToStandart(value)
                    }
                })
            }
        });
    }
}

export default transformDateFields;

